import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import OnboardingModal from '../components/OnboardingModal';
import SocialLinks, { PHONE_DISPLAY, WHATSAPP_URL } from '../components/SocialLinks';

/* Theme-aware form field style (flips automatically between dark/light) */
const FIELD_STYLE = {
  background: 'var(--bg-surface-elevated)',
  border: '1px solid var(--border-medium)',
  padding: '12px',
  borderRadius: '6px',
  color: 'var(--text-primary)',
};

const ContactPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');
  const [submitted, setSubmitted] = useState(false);

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

      <main style={{ padding: '60px 0 80px 0' }}>
        <div className="jmi-container">
          <div className="section-header-center">
            <div className="section-label">OPERATIONS DESK</div>
            <h1 className="section-title">
              Contact <span className="gold-gradient-text">JMI Operating Network</span>
            </h1>
            <p className="section-subtitle">
              Reach our trade support desk, bullion settlement officers, and logistics coordinating team.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '36px',
            maxWidth: '1000px',
            margin: '0 auto',
          }}>
            {/* Direct Contact Info */}
            <div className="jmi-card">
              <h3 style={{ fontSize: '1.35rem', marginBottom: '20px', color: 'var(--text-primary)' }}>Corporate & Desk Hours</h3>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                <div>
                  <div style={{ color: 'var(--gold-400)', fontWeight: 'bold', marginBottom: '4px' }}>HEADQUARTERS & REGISTERED OFFICE</div>
                  <div style={{ color: 'var(--text-primary)', fontWeight: '600' }}>7RAYS GLOBAL PRIVATE LIMITED</div>
                  <div style={{ fontFamily: 'var(--font-mono)', color: 'var(--tech-accent)', fontSize: '0.82rem' }}>CIN: U47733GJ2026PTC171774</div>
                  <div>Surat, Gujarat, 395010 - India.</div>
                </div>

                <div>
                  <div style={{ color: 'var(--gold-400)', fontWeight: 'bold', marginBottom: '4px' }}>B2B PARTNER SUPPORT HOTLINE (WHATSAPP)</div>
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontFamily: 'var(--font-mono)', fontSize: '1.05rem', color: 'var(--text-primary)', textDecoration: 'none', fontWeight: 700 }}
                  >
                    {PHONE_DISPLAY}
                  </a>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Mon - Sat: 10:00 AM - 8:00 PM IST</div>
                </div>

                <div>
                  <div style={{ color: 'var(--gold-400)', fontWeight: 'bold', marginBottom: '4px' }}>OFFICIAL VERIFICATION DESK</div>
                  <div>support@jmigroup.com</div>
                  <div>trade@jmijewels.com</div>
                </div>

                <div>
                  <div style={{ color: 'var(--gold-400)', fontWeight: 'bold', marginBottom: '4px' }}>SECURED LOGISTICS DISPATCH</div>
                  <div>Vault pickup queries: dispatch@jmigroup.com</div>
                </div>
                <SocialLinks variant="contact" />
              </div>
            </div>

            {/* Inquiry Form */}
            <div className="jmi-card">
              <h3 style={{ fontSize: '1.35rem', marginBottom: '16px', color: 'var(--text-primary)' }}>Send Trade Inquiry</h3>
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '40px 10px' }}>
                  <div style={{ fontSize: '2rem', color: '#10B981', marginBottom: '12px' }}>✓</div>
                  <h4 style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>Inquiry Received</h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.88rem' }}>
                    An operational representative from JMI will respond within 2 business hours.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleContactSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  <input
                    type="text"
                    placeholder="Your Name & Enterprise Name"
                    required
                    style={FIELD_STYLE}
                  />
                  <input
                    type="tel"
                    placeholder="Contact Number (+91)"
                    required
                    style={FIELD_STYLE}
                  />
                  <input
                    type="email"
                    placeholder="Business Email"
                    required
                    style={FIELD_STYLE}
                  />
                  <textarea
                    rows="4"
                    placeholder="Details of wholesale enquiry, category interests, or seller onboarding..."
                    required
                    style={{ ...FIELD_STYLE, fontFamily: 'inherit' }}
                  ></textarea>
                  <button type="submit" className="btn btn-primary w-full">
                    Transmit Message →
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default ContactPage;
